import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";
import Cookies from "js-cookie";

const parseResponse = async (res, fallback) => {
  const text = await res.text();
  const data = text ? JSON.parse(text) : fallback;
  if (!res.ok) {
    throw new Error(data?.message || `Request failed with status ${res.status}`);
  }
  return data;
};

export const getLogs = async (token, filters = {}) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/mantisLogs/list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(filters),
  });
  return parseResponse(res, { logs: [], pagination: {} });
};

export const getLogById = async (token, logId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/mantisLogs/${logId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
  });
  const data = await res.json();
  return data;
};

export const getLogStats = async (token, filters = {}) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/mantisLogs/stats`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(filters),
  });
  return parseResponse(res, { total: 0, byType: [] });
};

export const deleteLog = async (token, logId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/mantisLogs/${logId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
  });
  const data = await res.json();
  return data;
};
